import { Checkbox, TextBase, TextCaption } from '@carboncopyco/ui';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useGuidedSandboxModifications } from '../Share/useGuidedSandboxModifications';
import {
  useDemoLinkAllowSignUp,
  useDemoLinkGuidanceTooltips,
  useDemoLinkPlatform,
  useDemoLinkProps,
  useDemoLinkWithGiveADemo,
} from './DemoLinkModalContext';

export const DemoLinkSettings = ({
  disabled,
  demoId,
}: {
  disabled?: boolean;
  demoId: string;
}) => {
  const { organizationId } = useDemoLinkProps();
  const [_platform] = useDemoLinkPlatform();
  const [allowSignUp, setAllowSignUp] = useDemoLinkAllowSignUp();
  const [withGiveADemo, setWithGiveADemo, allowWithoutGiveADemo] =
    useDemoLinkWithGiveADemo();
  const [_showGuidanceTooltip, _setShowGuidanceTooltip] =
    useDemoLinkGuidanceTooltips();
  const _flags = useFlags();

  const { guidanceTooltips } = useGuidedSandboxModifications({
    organizationId,
    demoId,
  });

  return (
    <div className="w-full">
      <TextCaption
        label="Link Settings"
        color="text-ds-natural-600"
      />
      <div className="w-full">
        <Checkbox
          disabled={disabled}
          name="allowSignUp"
          checked={allowSignUp}
          onChange={() => setAllowSignUp(!allowSignUp)}
          label={
            <TextBase
              label="Allow sign-up using this link"
              color="text-ds-natural-600"
            />
          }
        />
      </div>
      {allowWithoutGiveADemo && (
        <div className="w-full">
          <Checkbox
            disabled={disabled}
            checked={withGiveADemo}
            name="withGiveADemo"
            onChange={() => setWithGiveADemo(!withGiveADemo)}
            label={
              <TextBase
                label="Include presentation setup step"
                color="text-ds-natural-600"
              />
            }
          />
        </div>
      )}
      {/* {
        platform === DemoLinkPlatform.web &&
        guidanceTooltips.length > 0 && (
          <Checkbox
            name="showGuidanceTooltip"
            checked={showGuidanceTooltip}
            onChange={() => setShowGuidanceTooltip(!showGuidanceTooltip)}
            label={
              <TextBase
                label="Enable guided sandbox tooltips"
                color="text-ds-natural-600"
              />
            }
          />
        )} */}
    </div>
  );
};
